import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "py-3" }
const _hoisted_3 = { class: "py-4 row form-group" }
const _hoisted_4 = {
  class: "col-md-3 form-group",
  style: {"margin-top":"24px"}
}
const _hoisted_5 = {
  class: "form-label",
  for: "input-forecast-criteria"
}
const _hoisted_6 = {
  disabled: "",
  value: ""
}
const _hoisted_7 = {
  key: 1,
  value: 'SCOPES'
}
const _hoisted_8 = {
  key: 2,
  value: 'CATEGORIES'
}
const _hoisted_9 = {
  key: 3,
  value: 'ENERGY'
}
const _hoisted_10 = {
  key: 4,
  value: 'PROCUREMENT'
}
const _hoisted_11 = {
  key: 5,
  value: 'TRANSPORT'
}
const _hoisted_12 = {
  key: 6,
  value: 'TRASH'
}
const _hoisted_13 = {
  key: 7,
  value: 'PRODUCTS'
}
const _hoisted_14 = { class: "col-md-3 form-group extra-specific" }
const _hoisted_15 = {
  id: "multiselect-scopes-label",
  class: "form-label",
  for: "input-forecast-scope"
}
const _hoisted_16 = { class: "multiselect-wrapper" }
const _hoisted_17 = { class: "col-md-4 form-group" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  id: "forecast-result-chart"
}
const _hoisted_20 = {
  key: 1,
  class: "forecast-column-chart-placeholder"
}
const _hoisted_21 = { style: {"align-self":"center"} }
const _hoisted_22 = {
  class: "icon-svg",
  "aria-hidden": "true",
  style: {"display":"block","text-align":"center","margin":"auto"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#report-problem" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "forecast-column-chart-placeholder"
}
const _hoisted_26 = { style: {"align-self":"center"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  "aria-label": "Indlæser",
  class: "spinner"
}, null, -1)
const _hoisted_28 = {
  class: "spinner-status",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ForecastColumnChart = _resolveComponent("ForecastColumnChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formValidation.clearValidField && _ctx.formValidation.clearValidField(...args))),
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        onInvalidCapture: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formValidation.handleFormValidity && _ctx.formValidation.handleFormValidity(...args)), ["prevent"])),
        ref: "formGroup"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope123.field.forecast-criteria.name" })
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "options",
              id: "input-forecast-criteria",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedForecastCriteria) = $event))
            }, [
              _createElementVNode("option", _hoisted_6, [
                _createVNode(_component_SimpleText, { "text-key": "generic.input.dropdown.option-select.name" })
              ]),
              (_openBlock(), _createElementBlock("option", _hoisted_7, "Scopes")),
              (_openBlock(), _createElementBlock("option", _hoisted_8, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.filter.option.headeroption" })
              ])),
              (_ctx.hasGrouping(1))
                ? (_openBlock(), _createElementBlock("option", _hoisted_9, [
                    _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.energy" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasGrouping(2))
                ? (_openBlock(), _createElementBlock("option", _hoisted_10, [
                    _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.purchases" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasGrouping(3))
                ? (_openBlock(), _createElementBlock("option", _hoisted_11, [
                    _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.transport" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasGrouping(4))
                ? (_openBlock(), _createElementBlock("option", _hoisted_12, [
                    _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.garbage" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasGrouping(5))
                ? (_openBlock(), _createElementBlock("option", _hoisted_13, [
                    _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.products" })
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vModelSelect, _ctx.selectedForecastCriteria]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope123.field.forecast-scope.name" })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.selectedScopes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedScopes) = $event)),
                mode: "tags",
                "close-on-select": false,
                hideSelected: false,
                canClear: false,
                groups: false,
                options: _ctx.possibleScopes,
                valueProp: "scopeId",
                label: "scopePresentationName",
                id: "input-forecast-scope",
                ref: "input-forecast-scope",
                class: "multiselect-calculation form-group",
                aria: {'aria-labelledby':'multiselect-scopes-label', 'aria-placeholder': null, 'aria-multiselectable': null},
                placeholder: _ctx.getContentfulString('forecast.resultview.filter.placeholder.allscopesselected')
              }, null, 8, ["modelValue", "options", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              id: "submit-button-forecast-filter",
              class: "button button-primary",
              style: {"margin-top":"30px"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshChart())),
              disabled: _ctx.isPending
            }, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope123.button.submit.name" })
            ], 8, _hoisted_18)
          ])
        ])
      ], 544)
    ]),
    (_ctx.forecast.forcastHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("h4", null, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
          ]),
          (!_ctx.isLoadingPartially && !_ctx.isPending && !_ctx.hasFailed)
            ? (_openBlock(), _createBlock(_component_ForecastColumnChart, {
                key: 0,
                ref: "columnChart",
                "raw-data": _ctx.forecast.calculations?.sort((a, b) => a.year - b.year),
                settings: _ctx.chartSettings
              }, null, 8, ["raw-data", "settings"]))
            : (_ctx.hasFailed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24)),
                    _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.errorcalculatingforecast.message' }, null, 8, ["text-key"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_SimpleText, { "text-key": 'forecast.result.scope123.pendingload.chart' }, null, 8, ["text-key"])
                    ])
                  ])
                ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}